// Unsaved-changes navigation guard (same pattern as basketNavGuard.js).
//
// A screen with unsaved edits registers a guard; tab switches (BottomNav's
// beforeNavigate), the screen's own links and the Android back button ask it
// before leaving. The guard decides; the screen shows its own Save / Discard /
// Keep editing dialog and resumes the navigation afterwards.

var activeGuard = null;

/** Register (fn) or clear (null) the current guard. fn(destination) returns
 *  true when navigation may proceed, false when the screen took over. */
export function setUnsavedChangesGuard(fn) {
  activeGuard = typeof fn === 'function' ? fn : null;
}

/** Ask the active guard, if any. True means "go ahead". */
export function requestLeave(destination) {
  if (!activeGuard) return true;
  try {
    return activeGuard(destination) !== false;
  } catch (e) {
    return true;
  }
}

/** Pure decision used by guards: block only when there are unsaved edits and
 *  the destination actually leaves the current screen. */
export function shouldBlockLeave(dirty, destination, currentPath) {
  if (!dirty) return false;
  if (destination == null) return true; // back button: leaving
  return String(destination).split('?')[0] !== currentPath;
}
